import React from "react"
import styled from "styled-components"
import Testimonials from "../components/testimonials-cannabis"

import LOGO from "../images/CannabisEssentials_Logo.svg"
import PDF from "../assets/CannabisCloud_Overview.pdf"
import UNCaseStudyPDF from "../assets/CaseStudy_UpNorth.pdf"
import LibraCaseStudyPDF from "../assets/CaseStudy_Libra.pdf"

import UNImage from "../images/UpNorth_Case_Thumbnail.png"
import CEImage from "../images/CE_Overview_Thumbnail.png"

import SeedToSale from "../images/SeedToSale@2x.png"
import BrandData from "../images/Brand_Data@2x.png"
import BrandDataMonitor from "../images/DataBrannd_Monitor@2x.png"
import MetricMonitor from "../images/Metrc_Monitor@2x.png"

import Metric from "../images/Metrc@2x.png"

import Left from "../images/Image_Left@2x.png"
import Middle from "../images/Image_Middle@2x.png"
import Right from "../images/Image_Right@2x.png"

import comingSoon from "../images/Video_Thumbnail@2x.png"
import ReactModal from 'react-modal'


ReactModal.setAppElement('body')

const WrapperDiv = styled.div`
    max-width: 1110px;
    margin: 60px auto 0;
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;

    a {
        display: block;
    }

    .info {
        margin: 60px auto;
    }

    @media only screen and (max-width: 1140px) {
        margin-top: 0;
        margin-bottom: 0;

        a {
            width: 100%;
            display: block;
        }

        .info {
            max-height: 140px;
        }
    }

    #cannabisess {
        height: 73px; 
        margin-bottom: 40px;   
    }

    .video-link {
        display: inline-block;
        color: var(--text-grey);

        svg {
            display: inline-block;
            vertical-align: middle;
        }
    }

    .glow:hover img {
        box-shadow: rgba(0, 158, 219, 0.8) 0px 0px 20px 0px;
        transition: box-shadow .8s ease-in-out;
    }
    

`;

const SeeItAction = styled.div `
    background-color: #EAF8F5;
    padding-top: 40px;

    @media only screen and (max-width: 1024px) {
        padding-top: 100px;
    }
`

const Flex = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin-bottom: 100px;
    @media only screen and (max-width: 1024px) {
        margin-bottom: 90px;

        .mobile-1 {
            order: 1;
        }

        .mobile-2 {
            order: 2;
        }

        .mobile-3 {
            order: 3;
        }

        .mobile-4 {
            order: 4;
        }

        .mobile-5 {
            order: 5;
        }

        .mobile-6 {
            order: 6;
        }

        .mobile-7 {
            order: 7;
        }

        .mobile-8 {
            order: 8;
        }
        .mobile-9 {
            order: 9;
        }
        .mobile-10 {
            order: 10;
        }
    }
`;

const Content = styled.div `
    width: 50%;
    margin-bottom: 160px;
   
    &.content.left {
        padding-left: 100px
    }

    &.content.right {
        padding-right: 100px;
    }

    @media only screen and (max-width: 1140px) {
        width: 100%;
        padding: 0;
        margin-bottom: 100px;

        &.content {
            margin-bottom: 0;
        }

        &.content.left {
            padding-left: 0;
        }

        &.content.right {
            padding-right: 0;
        }
    }


    &.text {
        padding-right: 10px;
        padding-left: 10px;
        @media only screen and (max-width: 1140px) {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }
   
    &.full-width {
        width:100%;
        padding-bottom: 0;
    }

    .row {
        justify-content: space-between;
        padding-bottom: 60px;

        &.last {
            padding-bottom: 0;
        }

        @media only screen and (max-width: 1140px) {
            padding-bottom: 0;
            .col-6 {
                padding-bottom: 60px;
            }
        }

    }

    .column {
       max-width: 45%;
    }
    
    @media only screen and (max-width: 1140px) {
        padding: 0;

        .column {
            max-width: unset;
         }

         img {
            max-width: 500px;
         }
    }
    
    @media only screen and (max-width: 768px) {
        img {
            max-width: 100%;
         }
    } 

    .img-container {
        display: flex;
        justify-content: center;
        width: 100%
    }
`;

const VideoIFrame = styled.iframe `
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-bottom: 0;
    border: 0;

    &.margin-top-40{
        width: 100%;
        height: 100%!important;
        min-height: 400px;
    }

    @media only screen and (max-width: 1140px) {
        width: 100%;
        height: 280px!important;
        min-height: 280px;

        &.margin-top-40{
            min-height: 200px!important;
        }
    }

`;

const Block = styled.div `
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -15px;
    justify-content: space-between;    
    text-align: center;

    &.two-items {
        justify-content: flex-start;
        
        > div {
            margin-right: 100px;
        } 
    }
    @media only screen and (max-width: 1140px) {
        margin-top: 120px;
    }

    > div {
        max-width: 320px;

        @media only screen and (max-width: 1140px) {
            width: 100%;
            max-width: unset;
            margin-bottom: 30px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    #cannabisess {
        height: 31px;
        margin-bottom: 20px;
        margin-top: -5px;
    }

    svg {
        height: 31px;
        width: 255px;
        margin-bottom: 20px;

        &.certinia {
            width: 97px;
        }
    }

`
const ModalDiv = styled.div `
    overflow: auto;
    @media only screen and (max-width: 600px) {
        max-height: 300px;
    }
`
const CloseModalLink = styled.a `
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`


const closeSVG = () => (
    <svg width="27px" height="28px" viewBox="0 0 27 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g id="ABOUT-/-Profile-Card" transform="translate(-506.000000, -19.000000)" stroke="#3D7BB2" stroke-width="3">
                <g id="Group" transform="translate(506.894034, 21.000000)">
                    <path d="M1,0.5 L23.7184681,23.2184681" id="Line-3"></path>
                    <path d="M1,0.5 L23.7184681,23.2184681" id="Line-3-Copy" transform="translate(12.500000, 12.000000) rotate(88.000000) translate(-12.500000, -12.000000) "></path>
                </g>
            </g>
        </g>
    </svg>
)

const playIcon = () => (
    <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Website" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="CannabisEssentials---Desktop" transform="translate(-333.000000, -1008.000000)">
            <g id="SEED-TO-SALE" transform="translate(215.000000, 854.000000)">
                <g id="Bullets" transform="translate(1.000000, 150.000000)">
                    <g id="Group" transform="translate(117.000000, 4.500000)">
                        <circle id="Oval" stroke="#6A7C92" stroke-width="2" fill="#6A7C92" cx="8" cy="8" r="7"></circle>
                        <path d="M6.54470431,3.93844706 L11.6579015,7.15305033 C12.1254614,7.44699947 12.2662009,8.0643246 11.9722517,8.53188459 C11.8914288,8.66044273 11.7823891,8.76890567 11.6534042,8.84904564 L6.54020702,12.0259388 C6.07109467,12.3174041 5.45452462,12.1733928 5.16305927,11.7042804 C5.06462595,11.5458524 5.01246231,11.3630527 5.01246231,11.1765357 L5.01246231,4.78503932 C5.01246231,4.23275457 5.46017756,3.78503932 6.01246231,3.78503932 C6.20078199,3.78503932 6.38527433,3.83821542 6.54470431,3.93844706 Z" id="Path-2" fill="#FFFFFF"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

class ContentClass extends React.Component {
    constructor(props) {
        super();
        this.location = props.location.location;
        const params = new URLSearchParams(this.location.search)
        this.state = {
            watch_video: this.location.search && this.location.search.includes('watch_video'),
            tracking_source: this.location.search && this.location.search.includes('utm_source') ? params.get('utm_source') : 'Other',
            submitted: this.location.search && this.location.search.includes('submit')
        };
    }
      handleModalOpen = event => {
        this.setState({ isModalOpen: true })
      }
      handleModal2Open = event => {
        this.setState({ isModal2Open: true })
      }

      handleModalVideoOpen = event => {
        this.setState({ isModalVideoOpen: true })
      }

      handleModalVideo2Open = event => {
        this.setState({ isModalVideo2Open: true })
      }

      handleModalVideo3Open = event => {
        this.setState({ isModalVideo3Open: true })
      }

      handleModalVideo4Open = event => {
        this.setState({ isModalVideo4Open: true })
      }

      handleModalVideo5Open = event => {
        this.setState({ isModalVideo5Open: true })
      }

      handleModalVideo6Open = event => {
        this.setState({ isModalVideo6Open: true })
      }

      handleModalClose = event => {
        this.setState({ isModalOpen: false })
        this.setState({ isModal2Open: false })
        this.setState({ isModalVideoOpen: false })
        this.setState({ isModalVideo2Open: false })
        this.setState({ isModalVideo3Open: false })
        this.setState({ isModalVideo4Open: false })
        this.setState({ isModalVideo5Open: false })
        this.setState({ isModalVideo6Open: false })

    }

    render() {
        return (
            <>
            <WrapperDiv id="cannabisContent">
                 <img className="Logo" src={LOGO} alt="Cannabis Essential Logo" id="cannabisess"/>
                <Flex>
                   <Content className="content right mobile-1">
                        <h3 className="intro margin-bottom-10">Seed to Sale Software</h3>
                        <p className="margin-bottom-20"> Run your entire Cannabis business from Seed to Sale on the proven, scalable Salesforce Platform:</p>
                        
                        <p className="margin-bottom-10"><a href="javascript:void(0)" onClick={this.handleModalVideoOpen} className="video-link"><strong>{playIcon()} Procurement</strong></a></p>
                        <p className="margin-bottom-10"><a href="javascript:void(0)" onClick={this.handleModalVideo2Open} className="video-link"><strong>{playIcon()} Multi Channel Order fulfillment </strong></a></p>
                        <p className="margin-bottom-10"><a href="javascript:void(0)" onClick={this.handleModalVideo3Open} className="video-link"><strong>{playIcon()} Repackaging & Manufacturing </strong></a></p>
                        <p className="margin-bottom-10"><a href="javascript:void(0)" onClick={this.handleModalVideo4Open} className="video-link"><strong>{playIcon()} METRC Integration  </strong></a></p>
                        <p className="margin-bottom-10"><a href="javascript:void(0)" onClick={this.handleModalVideo5Open} className="video-link"><strong>{playIcon()} Accounting  </strong></a></p>
                        <p className="margin-bottom-40"><a href="javascript:void(0)" onClick={this.handleModalVideo6Open} className="video-link"><strong>{playIcon()} Cultivation  </strong></a></p>                        
                   </Content>
                   <Content className="image mobile-2">
                        <img src={SeedToSale} alt="Seed to Sale Image | Two individals at a counter browsing Cannabis Selection"/>
                   </Content>

                   <Content className="image mobile-4">
                        <img src={BrandData} alt="Brand Data Image | An individal working in a lab"/>
                   </Content>

                   <Content className="content left mobile-3 glow">
                        <h3 className="intro margin-bottom-10">Control Your Brand and Data</h3>
                        <p className="margin-bottom-20">With Cannabis Essential you control your brand and data. Run your entire business from seed to sales on the Salesforce platform with integrated analytics at every step.</p>
                        <a href="javascript:void(0)" onClick={this.handleModalOpen}><img src={BrandDataMonitor} alt="Brand Data Monitor displaying the integration with Salesforce"/></a>
                   </Content>

                   <Content className="content right mobile-5 glow">
                        <h3 className="intro margin-bottom-10">Fully METRC Integrated</h3>
                        <p className="margin-bottom-20">Cannabis Essentials directly integrates Salesforce with METRC, supporting Cultivation, Distribution, Manufacturing and Retail.</p>
                        <a href="javascript:void(0)" onClick={this.handleModal2Open}><img src={MetricMonitor} alt="Metrc Monitor displaying the integration with Salesforce and METRC"/></a>
                   </Content>

                   <Content className="mobile-6">
                        <img src={Metric} alt="Metric Image | An individal inspecting a cannabis plant"/>
                   </Content>
                   
                   <Content className="mobile-7 text">
                        <p>As the Cannabis industry grows and consolidates, operators are increasingly looking for a secure, auditable solution that integrates with track and trace and can scale with their fast growing businesses. Certinia (formerly FinancialForce) is the leading ERP solution, built natively on the Salesforce platform. </p>
                    </Content>
                   
                    <Content className="mobile-8 text">
                        <p>Ladd Partners is a certified METRC integration partner with unmatched experience implementing Salesforce and Certinia for Cannabis companies that are building for their future in this exciting market.</p>
                    </Content>
                   
                   <Block className="mobile-9">
                        <div>
                            <img src={Left} alt="Metric Image | An individal inspecting a cannabis plant"/>
                        </div>
                        <div>
                            <img src={Middle} alt="Metric Image | An individal inspecting a cannabis plant"/>
                        </div>
                        <div>
                            <img src={Right} alt="Metric Image | An individal inspecting a cannabis plant"/>
                        </div>
                    </Block>
                </Flex>
            </WrapperDiv>

            <Testimonials/>

            <SeeItAction>
                <WrapperDiv>
                    <Flex className="margin-bottom-0">
                        <h3 className="intro margin-bottom-10">See it in action</h3>
                        <p className="margin-bottom-60">Each of the short videos below showcases a different function of the Cannabis Essentials Solution. See for yourself how our integrated solution, all running on the Salesforce platform provides Operators with the full Seed to Sale solution:</p>
                    
                        <Content className="full-width">
                        <div className="row">
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content">
                                    <VideoIFrame src="https://player.vimeo.com/video/862551551?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                                    <h3 className="margin-bottom-0">Procurement</h3>
                                    <p>Centralized procurement lets you control spending and understand inventory availability. METRC integration imports your inbound manifests to minimize data entry.</p>
                                </span>
                            </div>
                        </div>
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content">
                                    <VideoIFrame src="https://player.vimeo.com/video/862549996?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                                    <h3 className="margin-bottom-0">Multi Channel Order fulfillment</h3>
                                    <p>Manage orders and delivery across channels for both B2B and B2C with a single source of truth for inventory and sales. METRC integration allows package tags to be managed directly from Salesforce.</p>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content"> 
                                    <VideoIFrame src="https://player.vimeo.com/video/862550866?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                                    <h3 className="margin-bottom-0">Repackaging & Manufacturing</h3>
                                    <p>Manage your re-packaging and manufacturing operations from the same application. Ability to track both tangible and intangible costs, and understand the actual cost of each batch. METRC integration allows for package tagging directly from Salesforce.</p>
                                </span>
                            </div>
                        </div>
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content">
                                    <VideoIFrame src="https://player.vimeo.com/video/862548725?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                                    <h3 className="margin-bottom-0">METRC Integration</h3>
                                    <p>METRC integrated to the full extent currently supported by METRC. This allows most functions to be performed in Salesforce and then automatically reported to METRC, either on demand or on a scheduled basis. Reporting is fault tolerant and self documenting.</p>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content">
                                    <VideoIFrame src="https://player.vimeo.com/video/875365810?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479" className="videoIframe" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                                    <h3 className="margin-bottom-0">Accounting</h3>
                                    <p>Accounting is fully integrated into the solution, rather than being a separate application. Includes the ability to maintain and consolidate multiple sets of books and to automatically summarize and journal sales and inventory transactions.</p>
                                </span>
                            </div>
                        </div>
                    
                        <div className="column col-6">
                            <div className="service-block">
                                <span className="content">
                                <img src={comingSoon} alt="Coming Soon Placeholder"/>
                                    <h3 className="margin-bottom-0">Cultivation</h3>
                                    <p>Manage cultivation activities directly from the application including the ability to create batches, tag plants and A/B test to optimize yields. Integrated with accounting to track and  understand costs. METRC integration allows reporting to METRC directly from the application.</p>
                                </span>
                            </div>
                        </div>
                    </div>
                    </Content>
                    </Flex>
                </WrapperDiv>
            </SeeItAction>
            <WrapperDiv className="margin-top-100">
                <h3>Solutions Overview and Case Studies</h3>
                <Block className="margin-bottom-160 margin-top-40 two-items">
                    <div>
                        <a href={PDF} target="_blank" className="glow">
                            <img src={CEImage} alt="UpNorth Case Study Preview"/>
                            <h4>Solutions Overview <br/> (PDF)</h4>
                        </a>
                    </div>
                    <div>
                        <a href={UNCaseStudyPDF} target="_blank" className="glow">
                            <img src={UNImage} alt="Metric Image | An individal inspecting a cannabis plant"/>
                            <h4>UpNorth Case Study <br/> (PDF)</h4>
                        </a>
                    </div>
                </Block>
            </WrapperDiv>

            <ReactModal isOpen={this.state.isModalOpen}
                        className="Modal large"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalOpen: false });
                        }} >
                <ModalDiv> 
                    <img src={BrandDataMonitor} alt="Brand Data Monitor displaying the integration with Salesforce"/>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
            <ReactModal isOpen={this.state.isModal2Open}
                        className="Modal large"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModal2Open: false });
                        }} >
                <ModalDiv> 
                    <img  src={MetricMonitor} alt="Metrc Monitor displaying the integration with Salesforce and METRC"/>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>

            {/* Video Modals */}

            <ReactModal isOpen={this.state.isModalVideoOpen}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideoOpen: false });
                        }} >
                <ModalDiv> 
                    <VideoIFrame src="https://player.vimeo.com/video/862551551?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>

            <ReactModal isOpen={this.state.isModalVideo2Open}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideo2Open: false });
                        }} >
                <ModalDiv> 
                    <VideoIFrame src="https://player.vimeo.com/video/862549996?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
            <ReactModal isOpen={this.state.isModalVideo3Open}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideo3Open: false });
                        }} >
                <ModalDiv> 
                    <VideoIFrame src="https://player.vimeo.com/video/862550866?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
            <ReactModal isOpen={this.state.isModalVideo4Open}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideo4Open: false });
                        }} >
                <ModalDiv> 
                    <VideoIFrame src="https://player.vimeo.com/video/862548725?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
            <ReactModal isOpen={this.state.isModalVideo5Open}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideo5Open: false });
                        }} >
                <ModalDiv> 
                    <VideoIFrame src="https://player.vimeo.com/video/875365810?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479" className="videoIframe margin-top-40" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></VideoIFrame>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
            <ReactModal isOpen={this.state.isModalVideo6Open}
                        className="Modal video"
                        overlayClassName="Overlay"
                        shouldCloseOnOverlayClick={true}
                        onRequestClose={() => {
                            this.setState({ isModalVideo6Open: false });
                        }} >
                <ModalDiv> 
                    <img src={comingSoon} alt="Coming Soon Placeholder" className="margin-top-40"/>
                </ModalDiv>
                <CloseModalLink onClick={this.handleModalClose}>
                    {closeSVG()}
                </CloseModalLink>
            </ReactModal>
        </>
        )
    }
}

export default ContentClass
